import { ContainerWithPadding } from "../components/shared"
import { graphql } from "gatsby"
import Layout from "../components/Layout"
import React, { FC } from "react"
import { TeamMemberContainer } from "../components/TeamMember/TeamMemberContainer"
import { TopBlock } from "../components/TopBlock/TopBlock"
import { TopBlockCounters } from "../components/TopBlock/TopBlockCounters"
import { PageWithQuery } from "../types/PageWithQuery"
import { TeamMember } from "../types/TeamMember"

const TeamPage: FC<
  PageWithQuery<{
    teamMembers: TeamMember[]
  }>
> = ({
  data: {
    pageData: {
      frontmatter: { teamMembers },
    },
    translationData: {
      frontmatter: {
        topBlockStatistic,
        address,
        navigationItems,
        contactUsTitle,
        phoneNumberText,
        areasTitle,
        learnMoreText,
      },
    },
    commonData: {
      frontmatter: { phoneNumber, email, addressCoordinates },
    },
  },
}) => {
  return (
    <Layout
      lang="ru"
      address={address}
      phoneNumber={phoneNumber}
      email={email}
      navigationItems={navigationItems}
      contactUsTitle={contactUsTitle}
      addressCoordinates={addressCoordinates}
    >
      <ContainerWithPadding padding={`32px 32px 0`}>
        <TopBlock>
          <div className="bottom">
            <TopBlockCounters counters={Object.values(topBlockStatistic)} />
          </div>
        </TopBlock>
        <TeamMemberContainer
          teamMembers={teamMembers}
          phoneNumberText={phoneNumberText}
          areasTitle={areasTitle}
          learnMoreText={learnMoreText}
        />
      </ContainerWithPadding>
    </Layout>
  )
}

export default TeamPage

export const pageQuery = graphql`
  {
    pageData: markdownRemark(
      frontmatter: { lang: { eq: "ru" }, pageType: { eq: "team" } }
    ) {
      frontmatter {
        teamMembers {
          description
          experience
          fields
          name
          phoneNumber
          photo
        }
      }
    }
    translationData: markdownRemark(
      frontmatter: { lang: { eq: "ru" }, pageType: { eq: "translations" } }
    ) {
      frontmatter {
        navigationItems {
          about
          blog
          contacts
          team
        }
        contactUsTitle
        address
        phoneNumberText
        areasTitle
        learnMoreText
        topBlockStatistic {
          ares {
            number
            title
          }
          wonCases {
            number
            title
          }
          years {
            number
            title
          }
        }
      }
    }
    commonData: markdownRemark(frontmatter: { pageType: { eq: "common" } }) {
      frontmatter {
        phoneNumber
        email
        addressCoordinates {
          lat
          lng
        }
      }
    }
  }
`
